import React from 'react';
import { View } from 'react-native';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { isWebView } from 'src/utils/platform';
import useDebugSettingsStorage from './storage/settings/hook';
import tenancyBannerColor from './tenancyBannerColor';
const BANNER_HEIGHT = 16;
const TenancyBanner = () => {
    const [{ styles, dimensions }] = useTheme(stylesGenerator);
    const [debugSettings] = useDebugSettingsStorage();
    if (!__DEV__)
        return null;
    const inset = isWebView ? 0 : dimensions.safeAreaInsets.top;
    return (React.createElement(View, { style: [
            styles.banner,
            {
                backgroundColor: tenancyBannerColor(debugSettings.tenancy),
                paddingTop: inset,
                height: BANNER_HEIGHT + inset,
            },
        ] }));
};
const stylesGenerator = createThemedStyle(() => ({
    banner: {
        justifyContent: 'center',
        zIndex: 20,
    },
    label: {
        fontSize: 10,
        lineHeight: BANNER_HEIGHT,
    },
}));
export default TenancyBanner;
